<template>
  <div
    class="box-wait horizontal layout center"
    :style="{'background-color': boxWaitBg}"
  >
    <CountDownCycleV2
      v-if="countTimeToAnswer"
      :theme="theme"
      :count-time-to-answer="countTimeToAnswer + 's'"
      @countDownReady="$emit('countDownReady')"
    />

    <div class="count-down-answer horizontal layout center">
      <span ref="timeToAnswer" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Util from '@/util'
import Config from '@/config'
import Socket from '@/socket'
import EventBus from '@/eventBus'
import CountDownCycleV2 from '@/components/presentations/CountDownCycleV2.vue'

export default {
  components: {
    CountDownCycleV2,
  },
  props: {
    theme: {
      type: String,
      default: 'light',
    },
  },
  data() {
    return {
      countTimeToAnswer: 0,
      boxWaitBg: '',
      requestFrame: null,
      errorUpdateStopSubmission: false,
    }
  },

  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },

  watch: {
    // eslint-disable-next-line func-names
    '$store.state.slideActive.stopSubmission': function (stop) {
      this.cancelAnimationFrame()
      if (!stop && this.slideActive.hasTimeLimit) {
        this.startCountDownTimeToAnswer()
      }
    },
  },

  mounted() {
    if (!this.slideActive.stopSubmission && this.slideActive.hasTimeLimit) {
      this.updateSubmissionTime()
    }

    EventBus.$on('resetTimeToAnswer', () => {
      this.updateSlideActiveAction({
        stopSubmission: false,
      })
      this.updateSubmissionTime()
      EventBus.$emit('resetCycle', `${this.slideActive.timeToAnswer}s`)
    })
  },

  destroyed() {
    this.cancelAnimationFrame()
    EventBus.$off('resetTimeToAnswer')
  },

  methods: {
    ...mapActions(['updateSlideActiveAction']),
    updateSubmissionTime() {
      let { stopSubmissionTime } = this.slideActive
      const { stopSubmission, timeToAnswer, hasTimeLimit } = this.slideActive
      if (!stopSubmission && timeToAnswer && hasTimeLimit) {
        stopSubmissionTime =
          new Date().getTime() +
          this.slideActive.timeToAnswer * 1000
        this.updateSlideActiveAction({
          stopSubmissionTime,
        })
      }
      // Update stopSubmissionTime & undo stopSubmission, then start counting
      this.cancelAnimationFrame()
      this.updateSlide(
        {
          stopSubmission: this.slideActive.stopSubmission,
          stopSubmissionTime,
          timeToAnswer: this.slideActive.timeToAnswer,
        },
        (err) => {
          if (!err) {
            this.startCountDownTimeToAnswer()
          }
        },
      )
    },
    startCountDownTimeToAnswer() {
      this.errorUpdateStopSubmission = false
      const self = this

      if (!this.slideActive.hasTimeLimit) return

      this.countTimeToAnswer = parseInt(
        this.slideActive.timeToAnswer,
        10,
      )

      let contextTimeToAnswer = self.$refs.timeToAnswer
      if (contextTimeToAnswer) {
        contextTimeToAnswer.textContent = Util.timeToString(
          self.countTimeToAnswer,
        )
      }

      let secondTime = 0

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime !== timeRun) {
          secondTime = timeRun

          self.countTimeToAnswer = parseInt(
            (self.$store.state.slideActive.stopSubmissionTime -
              new Date().getTime()) /
              1000,
            10,
          )
          contextTimeToAnswer = self.$refs.timeToAnswer

          if (contextTimeToAnswer) {
            contextTimeToAnswer.textContent = Util.timeToString(
              self.countTimeToAnswer,
            )
          }
        }

        if (
          !self.$store.state.slideActive.stopSubmission &&
          self.$store.state.slideActive.hasTimeLimit &&
          (!self.countTimeToAnswer || self.countTimeToAnswer <= 0)
        ) {
          self.updateSlideActiveAction({
            stopSubmission: true,
          })
          self.updateSlide({ stopSubmission: true }, (err) => {
            if (err) {
              self.updateSlideActiveAction({
                stopSubmission: false,
              })
            }
            self.cancelAnimationFrame()
          })
        }

        if (self.countTimeToAnswer > 0) {
          self.requestFrame = new Promise((resolve) => {
            requestAnimationFrame(resolve)
          }).then(step)
        } else {
          self.cancelAnimationFrame()
        }
      }
      self.requestFrame = window.requestAnimationFrame(step)
    },

    cancelAnimationFrame() {
      if (this.requestFrame) {
        window.cancelAnimationFrame(this.requestFrame)
      }
    },

    updateSlide(payload, cb) {
      const slideId = this.$store.state.slideActive.id
      const presentationId = this.$store.state.presentation.id
      if (this.$store.state.sharePresentation || !slideId || !presentationId) {
        return
      }

      const data = {
        ...payload,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        presenting: this.$store.getters.isPresenting,
        presentationId,
      }
      this.$store.dispatch('setSyncPresentation', 1)
      this.$http.put(Config.api.updateSlide + slideId, data).then(
        () => {
          this.$store.dispatch('setSyncPresentation', 2)
          if (cb) {
            cb()
          }
        },
        (err) => {
          this.errorUpdateStopSubmission = true
          if (cb && !this.errorUpdateStopSubmission) {
            cb(err)
          }
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.box-wait {
  min-width: 112px;
}

.count-down-answer {
  font-weight: 600;
  font-size: 26px;
  line-height: 36px;
  margin-left: 6px;

  span {
    margin-right: 2px;
    min-width: 60px;
    display: inline-block;
    position: relative;
    top: 2px;
  }
}
</style>
